export default __webpack_public_path__ + "static/media/about_mascot.c042736b.png";